import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=106ceb6f&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=106ceb6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106ceb6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('106ceb6f')) {
      api.createRecord('106ceb6f', component.options)
    } else {
      api.reload('106ceb6f', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=106ceb6f&scoped=true&", function () {
      api.rerender('106ceb6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fSorv4GTLcBg/JS/comp/DocBox.vue"
export default component.exports